import axios from "axios";

export interface GenerateAiBannerRequest {
  prompt: string;
  modelId: number;
  attachment?: File | null;
  attachmentUrl?: string | null;
  pageUrl?: string;
  productIds?: number[];
  width?: number;
  height?: number;
  skipAnalysis?: boolean;
}

export interface ModifyAiBannerRequest {
  prompt: string;
  chatId: string;
  pageUrl?: string;
}

export interface GenerateAiBannerResponse {
  url: string;
  chatId: string;
}

export const generateAiBanner = async (request: GenerateAiBannerRequest): Promise<GenerateAiBannerResponse> => {
  const formData = new FormData();
  formData.append("prompt", request.prompt);
  formData.append("model_id", request.modelId.toString());

  if (request.attachment) {
    formData.append("attachment", request.attachment, request.attachment.name);
  }
  if (request.attachmentUrl) {
    formData.append("attachment_url", request.attachmentUrl);
  }
  if (request.pageUrl) {
    formData.append("page_url", request.pageUrl);
  }
  if (request.productIds && request.productIds.length > 0) {
    formData.append("product_ids", request.productIds.join(","));
  }
  if (request.width) {
    formData.append("width", request.width.toString());
  }
  if (request.height) {
    formData.append("height", request.height.toString());
  }
  if (request.skipAnalysis !== undefined) {
    formData.append("skip_analysis", request.skipAnalysis.toString());
  }

  const { data } = await axios.post<GenerateAiBannerResponse>("/ai-banner/generate", formData);
  return data;
};

export const modifyAiBanner = async (request: ModifyAiBannerRequest): Promise<GenerateAiBannerResponse> => {
  const formData = new FormData();
  formData.append("prompt", request.prompt);
  formData.append("chat_id", request.chatId);
  if (request.pageUrl) {
    formData.append("page_url", request.pageUrl);
  }

  const { data } = await axios.post<GenerateAiBannerResponse>("/ai-banner/modify", formData);
  return data;
};

export const getHistory = async (): Promise<Array<string>> => {
  const { data } = await axios.get<Array<string>>("/ai-banner/history");
  return data;
};

export interface SubmitFeedbackRequest {
  feedback: string;
  sentiment: "positive" | "negative";
  prompt: string;
  modelId: number;
  attachmentUrl: string | null;
  generatedImageUrl: string | null;
}

export const submitFeedback = async (request: SubmitFeedbackRequest): Promise<void> => {
  await axios.post("/ai-banner/feedback", request);
};
